var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8099 9.63C33.6317 8.91811 33.2688 8.26586 32.7579 7.73911C32.2469 7.21236 31.606 6.82978 30.8999 6.63C28.3199 6 17.9999 6 17.9999 6C17.9999 6 7.67988 6 5.09988 6.69C4.39375 6.88978 3.75285 7.27236 3.2419 7.79911C2.73095 8.32586 2.36806 8.97811 2.18988 9.69C1.7177 12.3083 1.48673 14.9645 1.49988 17.625C1.48305 20.3056 1.71403 22.982 2.18988 25.62C2.38632 26.3098 2.75734 26.9372 3.2671 27.4417C3.77685 27.9462 4.40811 28.3107 5.09988 28.5C7.67988 29.19 17.9999 29.19 17.9999 29.19C17.9999 29.19 28.3199 29.19 30.8999 28.5C31.606 28.3002 32.2469 27.9176 32.7579 27.3909C33.2688 26.8641 33.6317 26.2119 33.8099 25.5C34.2784 22.9014 34.5094 20.2655 34.4999 17.625C34.5167 14.9444 34.2857 12.268 33.8099 9.63V9.63Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 22.5302L23.25 17.6252L14.625 12.7202V22.5302Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.df925cf833fcc8ead848ec5007180966.svg";
export { ForwardRef as ReactComponent };